/* Sara Elmsalati — storefront interactions
   Click behaviours use event delegation on document so they survive theme-editor
   section reloads. The hero slideshow holds timers, so it (re)initialises on
   shopify:section:load and is torn down on shopify:section:unload. */
(function () {
  'use strict';

  /* ---------------- Helpers ---------------- */
  function lockScroll(on) {
    document.body.style.overflow = on ? 'hidden' : '';
    if (window.__lenis) { on ? window.__lenis.stop() : window.__lenis.start(); }
  }
  function isMobile() { return window.matchMedia('(max-width: 900px)').matches; }
  function anyOverlayOpen() { return !!document.querySelector('.overlay.open'); }

  function closeMenu() {
    var panel = document.getElementById('menu-panel');
    var burger = document.getElementById('burger');
    if (panel) panel.classList.remove('open');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    if (!anyOverlayOpen()) lockScroll(false);
  }

  function closeOverlays() {
    document.querySelectorAll('.overlay.open').forEach(function (o) { o.classList.remove('open'); });
    lockScroll(false);
  }

  /* ---------------- Click delegation ---------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    /* Burger toggles the menu panel */
    var burger = t.closest('#burger');
    if (burger) {
      var panel = document.getElementById('menu-panel');
      var open = panel.classList.toggle('open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (isMobile()) lockScroll(open);
      else if (!anyOverlayOpen()) lockScroll(false);
      return;
    }

    /* Submenu accordions */
    var toggle = t.closest('.menu-toggle');
    if (toggle) {
      var id = toggle.getAttribute('aria-controls');
      var sub = id && document.getElementById(id);
      if (sub) {
        var isOpen = sub.classList.toggle('open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }
      return;
    }

    /* Clicking a menu link closes the panel (native anchor handles the scroll) */
    if (t.closest('#menu-panel a')) { closeMenu(); return; }

    /* Service "Learn more" → open service modal on the matching panel */
    var learn = t.closest('.learn-more');
    if (learn) {
      var sid = learn.getAttribute('data-service');
      var overlay = document.getElementById('service-overlay');
      if (overlay) {
        overlay.querySelectorAll('.service-modal-panel').forEach(function (p) {
          p.classList.toggle('active', p.getAttribute('data-service') === sid);
        });
        overlay.classList.add('open');
        lockScroll(true);
      }
      return;
    }

    /* Education tabs swap the card content */
    var tab = t.closest('.edu-tab');
    if (tab) {
      var grid = tab.closest('.edu-grid');
      if (grid) {
        grid.querySelectorAll('.edu-tab').forEach(function (x) { x.classList.remove('active'); });
        tab.classList.add('active');
        var title = grid.querySelector('.edu-card h3');
        var lead = grid.querySelector('.edu-lead');
        var desc = grid.querySelector('.edu-desc');
        if (title) title.textContent = tab.getAttribute('data-name') || '';
        if (lead) lead.textContent = tab.getAttribute('data-lead') || '';
        if (desc) desc.textContent = tab.getAttribute('data-desc') || '';
      }
      return;
    }

    /* Gallery card → open the lightbox built from that category's images */
    var gcard = t.closest('.gallery-card');
    if (gcard) { openLightbox(gcard); return; }

    /* Close buttons / backdrop */
    if (t.classList.contains('modal-close') || t.classList.contains('overlay')) {
      closeOverlays();
      return;
    }

    /* Contact "Send another request" */
    if (t.closest('#form-reset')) {
      var success = document.getElementById('form-success');
      var form = document.getElementById('booking-form');
      if (success) success.classList.remove('show');
      if (form) { form.style.display = ''; form.reset(); }
      return;
    }

    /* Outside click closes the menu */
    var menu = document.getElementById('menu-panel');
    if (menu && menu.classList.contains('open') && !t.closest('#menu-panel') && !t.closest('#burger')) {
      closeMenu();
    }
  });

  /* Escape closes menu + overlays */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeOverlays(); closeMenu(); }
  });

  /* ---------------- Gallery lightbox ---------------- */
  var lbState = { urls: [], i: 0 };

  function openLightbox(card) {
    var overlay = document.getElementById('lightbox-overlay');
    if (!overlay) return;
    var urls = [];
    try { urls = JSON.parse(card.getAttribute('data-images') || '[]'); } catch (err) { urls = []; }
    lbState.urls = urls;
    lbState.i = 0;

    overlay.querySelector('#lb-title').textContent = card.getAttribute('data-title') || '';
    var descEl = overlay.querySelector('#lb-desc');
    descEl.textContent = card.getAttribute('data-desc') || '';
    descEl.style.display = descEl.textContent ? '' : 'none';

    var stage = overlay.querySelector('#lb-stage');
    stage.querySelectorAll('image-slot').forEach(function (n) { n.remove(); });
    var dots = overlay.querySelector('#lb-dots');
    dots.innerHTML = '';

    if (urls.length === 0) {
      var empty = document.createElement('image-slot');
      empty.className = 'is-empty active';
      empty.setAttribute('data-placeholder', 'No images yet — add gallery images for this category');
      stage.appendChild(empty);
    } else {
      urls.forEach(function (url, idx) {
        var slot = document.createElement('image-slot');
        if (idx === 0) slot.className = 'active';
        slot.style.backgroundImage = "url('" + url + "')";
        stage.appendChild(slot);

        var dot = document.createElement('button');
        if (idx === 0) dot.className = 'active';
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Image ' + (idx + 1));
        dot.addEventListener('click', function () { lbShow(idx); });
        dots.appendChild(dot);
      });
    }

    var multi = urls.length > 1;
    overlay.querySelector('.lb-arrow.prev').style.display = multi ? '' : 'none';
    overlay.querySelector('.lb-arrow.next').style.display = multi ? '' : 'none';

    overlay.classList.add('open');
    lockScroll(true);
  }

  function lbShow(i) {
    var overlay = document.getElementById('lightbox-overlay');
    if (!overlay || lbState.urls.length === 0) return;
    var n = lbState.urls.length;
    lbState.i = (i + n) % n;
    var slots = overlay.querySelectorAll('#lb-stage image-slot');
    var dots = overlay.querySelectorAll('#lb-dots button');
    slots.forEach(function (s, idx) { s.classList.toggle('active', idx === lbState.i); });
    dots.forEach(function (d, idx) { d.classList.toggle('active', idx === lbState.i); });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.lb-arrow.prev')) { lbShow(lbState.i - 1); }
    else if (e.target.closest('.lb-arrow.next')) { lbShow(lbState.i + 1); }
  });

  /* ---------------- Contact: client-side validation ---------------- */
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.id !== 'booking-form') return;
    var ok = true;
    form.querySelectorAll('[required]').forEach(function (ctrl) {
      var field = ctrl.closest('.field');
      var v = (ctrl.value || '').trim();
      var bad = v === '' || (ctrl.type === 'email' && !validEmail(v));
      if (field) field.classList.toggle('invalid', bad);
      if (bad) ok = false;
    });
    if (!ok) e.preventDefault();
  });

  document.addEventListener('input', function (e) {
    var field = e.target.closest && e.target.closest('.field.invalid');
    if (field) field.classList.remove('invalid');
  });

  /* ---------------- Hero slideshow (lifecycle-managed) ---------------- */
  function setupHero(hero) {
    teardownHero(hero);
    var slides = hero.querySelectorAll('.hero-slide');
    var dots = hero.querySelectorAll('.hero-dots button');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Video slides: only the active slide plays; reduced-motion users keep the
       poster frame instead of autoplay. */
    function syncVideos() {
      slides.forEach(function (s) {
        var vid = s.querySelector('video');
        if (!vid) return;
        if (!reduceMotion && s.classList.contains('active')) {
          var p = vid.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          vid.pause();
        }
      });
    }
    syncVideos();

    if (slides.length <= 1) {
      hero.__heroCleanup = function () {
        slides.forEach(function (s) {
          var vid = s.querySelector('video');
          if (vid) vid.pause();
        });
      };
      return;
    }

    var i = 0;
    var seconds = parseFloat(hero.getAttribute('data-interval') || '5');

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, idx) { s.classList.toggle('active', idx === i); });
      dots.forEach(function (d, idx) { d.classList.toggle('active', idx === i); });
      syncVideos();
    }

    dots.forEach(function (dot, idx) {
      dot.addEventListener('click', function () { show(idx); restart(); });
    });

    var timer = null;
    function restart() {
      if (timer) clearInterval(timer);
      if (seconds > 0) timer = setInterval(function () { show(i + 1); }, seconds * 1000);
    }
    restart();

    hero.__heroCleanup = function () {
      if (timer) clearInterval(timer);
      timer = null;
      slides.forEach(function (s) {
        var vid = s.querySelector('video');
        if (vid) vid.pause();
      });
    };
  }

  function teardownHero(hero) {
    if (hero && typeof hero.__heroCleanup === 'function') { hero.__heroCleanup(); hero.__heroCleanup = null; }
  }

  function initHeroes(root) {
    (root.querySelectorAll ? root.querySelectorAll('.hero') : []).forEach(setupHero);
    if (root.classList && root.classList.contains('hero')) setupHero(root);
  }

  function initContact(root) {
    var success = (root.querySelector && root.querySelector('#form-success')) || document.getElementById('form-success');
    var form = (root.querySelector && root.querySelector('#booking-form')) || document.getElementById('booking-form');
    if (success && form && success.classList.contains('show')) form.style.display = 'none';
  }

  function initAll(root) { initHeroes(root); initContact(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    (e.target.querySelectorAll ? e.target.querySelectorAll('.hero') : []).forEach(teardownHero);
  });
})();
